import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";

import SignIn from "./pages/SignIn";
import SawaPage from "./pages/Sawa";
import AdminPage from "./Admin Pages/AdminPage";
import Home from "./pages/Home";
import Conservation from "./pages/Conservation";
import Artist from "./pages/Artist";
import ArtistDetails from "./pages/ArtistDetails";
import Shop from "./pages/Shop";
import ProtectedRoute from "./utils/ProtectedRoute";
import Services from "./pages/Services";
import ServiceDetails from "./pages/ServiceDetails";
import Commisions from "./pages/Commisions";
import Collections from "./pages/Collections";
import Product from "./pages/Product";
import ProductDetails from "./pages/ProductDetails";
import Cart from "./pages/Cart";
import Tabs from "./pages/Other";
import ContactSection from "./pages/ContactPage";
import ErrorPage from "./pages/ErrorPage";
import ArtistForm from "./Admin Components/ArtistForm";
import ArtForm from "./Admin Components/ArtForm";
import CategoryForm from "./Admin Components/CategoryForm";
import CollectionForm from "./Admin Components/CollectionForm";
import TeamForm from "./Admin Components/TeamForm";
import Artists from "./Admin Components/Artists";
import AdminDash from "./Admin Components/AdminDash";
import Add from "./Admin Components/Add";
import View from "./Admin Components/View";
import { Outlet } from "react-router-dom";
import Member from "./Admin Components/Member";
import Art from "./Admin Components/Art";
import CategoryView from "./Admin Components/CategoryView";
import CollectionView from "./Admin Components/CollectionView";
import ArtEditForm from "./Admin Components/ArtEditForm";
import ArtistEditForm from "./Admin Components/ArtistEditForm";
import TeamEditForm from "./Admin Components/TeamEditForm";
import CategoryEditForm from "./Admin Components/CategoryEditForm";
import CollectionEditForm from "./Admin Components/CollectionEditForm";

import ReactGA from "react-ga4";

const trackingID = "G-T4EF0V8B5B";
ReactGA.initialize(trackingID);
// ReactGA.send("pageview");

ReactGA.send({ hitType: "homePage", page: window.location.pathname });

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="sawa-admin-login" element={<SignIn />} />
        <Route
          path="admin/*"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
          >
          <Route path="dashboard" element={<AdminDash />} />

          <Route path="add" element={<Outlet />}>
            <Route index element={<Add />} />
            <Route path="art" element={<ArtForm />} />
            <Route path="artist" element={<ArtistForm />} />
            <Route path="collection" element={<CollectionForm />} />
            <Route path="categorie" element={<CategoryForm />} />
            <Route path="member" element={<TeamForm />} />
          </Route>

          <Route path="view" element={<Outlet />}>
            <Route index element={<View />} />
            <Route path="art" element={<Art />} />
            <Route path="artists" element={<Artists />} />
            <Route path="collections" element={<CollectionView />} />
            <Route path="categories" element={<CategoryView />} />
            <Route path="members" element={<Member />} />
          </Route>

          <Route path="edit" element={<Outlet />}>
            <Route path="art/:id" element={<ArtEditForm />} />
            <Route path="artist/:id" element={<ArtistEditForm />} />
            <Route path="collections/:id" element={<CollectionEditForm />} />
            <Route path="category/:id" element={<CategoryEditForm />} />
            <Route path="team/:id" element={<TeamEditForm />} />{" "}
            {/* Add the dynamic route */}
          </Route>
        </Route>
        <Route path="about-sawa" element={<SawaPage />} />
        <Route path="about-artists" element={<Artist />} />
        <Route path="artistDetails/:artistId" element={<ArtistDetails />} />
        <Route path="conservation" element={<Conservation />} />
        <Route path="commissions" element={<Commisions />} />
        <Route path="shop" element={<Shop />} />
        <Route path="shop/:id/collections" element={<Collections />} />
        <Route path="shop/:id/artworks" element={<Product />} />
        <Route path="product/:id" element={<ProductDetails />} />
        <Route path="services" element={<Services />} />
        <Route path="services/:serviceId" element={<ServiceDetails />} />
        <Route path="cart" element={<Cart />} />
        <Route path="sawa/faq" element={<Tabs />} />
        <Route path="sawa/privacy-policy" element={<Tabs />} />
        <Route path="sawa/terms-and-conditions" element={<Tabs />} />
        <Route path="contact" element={<ContactSection />} />

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
